import { sessionStore } from "../../utils/sessionStore.js";

export const SETTINGS_BASE_PATH = "/ajustes";
export const settingsPath = (section) => `${SETTINGS_BASE_PATH}/${section}`;
export const PLAN_PATH = settingsPath("plan");
export const BILLING_DETAILS_SECTION = "datos-facturacion";
export const BILLING_DETAILS_PATH = settingsPath(BILLING_DETAILS_SECTION);

export const BUY_HOURS_PATH = settingsPath("bono-horas");

export const isSettingsPath = (pathname) =>
  pathname === SETTINGS_BASE_PATH || pathname.startsWith(`${SETTINGS_BASE_PATH}/`);

// Última página fuera de Ajustes, para el botón de volver
const RETURN_PATH_KEY = "markezy_settings_return";
export const rememberSettingsReturnPath = (path) => sessionStore.set(RETURN_PATH_KEY, path);
export const readSettingsReturnPath = () => sessionStore.get(RETURN_PATH_KEY) || "/";
